import { singletonHook } from 'react-singleton-hook';
import useArtifactInfoService from '../artifactInfoService';
import type { ArtifactsInfoResponse } from '../types';
import useCreateArtifactsInfoReceiver, { filterValidArtifactIds } from './createArtifactsInfoReceiver';

type StaffingArtifactsInfoReceiver = {
  hookLoading: boolean;
  collectStaffingArtifactsData: (ids: string[]) => Promise<ArtifactsInfoResponse['artifacts']>;
};

const initState: StaffingArtifactsInfoReceiver = {
  hookLoading: true,
  collectStaffingArtifactsData: async () => ({}),
};

const useStaffingArtifactsInfoReceiverImpl = () => {
  const { getStaffingArtifactsInfo } = useArtifactInfoService();

  const collectStaffingArtifactsData = useCreateArtifactsInfoReceiver({
    getArtifactsInfo: getStaffingArtifactsInfo,
    getBatchIds: filterValidArtifactIds,
  });

  return {
    hookLoading: false,
    collectStaffingArtifactsData,
  };
};

const useStaffingArtifactsInfoReceiver = singletonHook(initState, useStaffingArtifactsInfoReceiverImpl);

export default useStaffingArtifactsInfoReceiver;
